"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDerivedState = void 0;
var React = require("react");
var useGlobal_1 = require("./useGlobal");
exports.useDerivedState = function (states, extractor) {
    var _a = __read(React.useState(extractor()), 2), derivedValue = _a[0], setDerivedValue = _a[1];
    var listener = React.useCallback(function (newVal, oldVal, index) {
        setDerivedValue(extractor.apply(void 0, __spread((states.map(function (index) { return useGlobal_1.curValues[index.__index__]; })))));
    }, [states, extractor]);
    React.useEffect(function () {
        states.forEach(function (index) {
            useGlobal_1.useGlobal.listen.on(index, listener);
        });
        return function () {
            states.forEach(function (index) {
                useGlobal_1.useGlobal.listen.off(index, listener);
            });
        };
    }, [states]);
    return derivedValue;
};
